import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import { useUser } from "../context/UserContext";
import '../styles/StatisticsManagement.css';
import ErrorScreen from "../components/ErrorScreen";
const StatisticsManagement = () => {
  const { userInfo } = useUser();

  const [roleType, setRoleType] = useState("");
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [error, setError] = useState(null); // 에러 처리
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState(""); 
  const [summary, setSummary] = useState({
  totalBuyIn: 0,
  totalBuyOut: 0,
  totalBetAmount: 0,
  totalRake: 0,
});

  const [page, setPage] = useState(0); // 페이지 번호
  const [size, setSize] = useState(10); // 페이지 크기
  const [totalPages, setTotalPages] = useState(0);

 
  // 빠른 시간 선택
  const setQuickTime = (type) => {
    const now = new Date();
  const formatter = (date) => {
        const localDate = new Date(date.getTime()); // KST 기준으로 변환

        const yyyy = localDate.getFullYear();
        const mm = String(localDate.getMonth() + 1).padStart(2, "0");
        const dd = String(localDate.getDate()).padStart(2, "0");
        const hh = String(localDate.getHours()).padStart(2, "0");
        const mi = String(localDate.getMinutes()).padStart(2, "0");
        const ss = String(localDate.getSeconds()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
      };
    setActiveFilter(type);
    switch (type) {
       case "thisMonth":
      const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfThisMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59);
      setStartDate(formatter(startOfThisMonth));
      setEndDate(formatter(endOfThisMonth));
      break;

    case "lastMonth":
      const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59);
      setStartDate(formatter(startOfLastMonth));
      setEndDate(formatter(endOfLastMonth));
      break;

      case "today":
        now.setHours(0, 0, 0, 0);
        setStartDate(formatter(now));
        setEndDate(formatter(new Date()));
        break;
      case "yesterday":
        const yesterday = new Date(now.getTime() - 86400000);
        yesterday.setHours(0, 0, 0, 0);
        setStartDate(formatter(yesterday));
        const yEnd = new Date(yesterday);
        yEnd.setHours(23, 59);
        setEndDate(formatter(yEnd));
        break;
    }
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}/admin/children`, {
       headers: {
              'X-Frontend-Request': 'true',
         
        },
      params: {
        username:userInfo.username,
        target:roleType
      },
    })
      .then((response) => {
        setUserList(response.data); // Page 객체라면 .content 접근 필요
        setSelectedUser(""); // 여기서 선택 초기화
      })
      .catch((error) => {
        setError(error.message); // 에러 발생 시 에러 메시지 상태에 저장
      }).finally(() => {
        setLoading(false);
      });
  }, [roleType]);  // 의존성도 같이 설정


  useEffect(() => {
    axios.get(`${API_BASE_URL}/bets`, {
       headers: {
              'X-Frontend-Request': 'true',
         
        },
      params: {
        page: page,     // 현재 페이지
        size: size,     // 페이지 당 항목 수
        start:startDate,
        end:endDate,
        username:userInfo.username,
        selectedUser:selectedUser === "" ? null : selectedUser,
        adminType:roleType === "" ? null : roleType,
        
      },
    })
      .then((response) => {
        setResult(response.data.content); // Page 객체라면 .content 접근 필요
     
        setTotalPages(response.data.totalPages); // 총 페이지 수 설정
    
      })
      .catch((error) => {
        setError(error.message); // 에러 발생 시 에러 메시지 상태에 저장
      }).finally(() => {
        setLoading(false);
      });
  }, [page, size,startDate,endDate,selectedUser,roleType]);  // 의존성도 같이 설정

   useEffect(() => {
  const fetchSummary = async () => {
    
    const params = {
      username:userInfo.username,
      selectedUser: selectedUser?.username,
      start: startDate,
      end: endDate
    };
    const { data } = await axios.get(`${API_BASE_URL}/bets/bet-summary`, {  headers: {
              'X-Frontend-Request': 'true',
         
        },params });
  
    setSummary(data);
  };

  fetchSummary();
}, [selectedUser, startDate, endDate]);

// 로딩 중일 때 로딩 메시지 표시
if (loading) {
  return (
    <div className="loading-overlay">
      <div className="loader"></div>
    </div>
  );
}

  return (
    <div className="container">
       <div className="container-inner">
      <h2>통계 관리</h2>
        {/* ✅ 요약 박스 */}
          <div className="summary-box">
               <div className="summary-item">
              <span className="label">총 바이인</span>
              <span className="value">{summary.totalBuyIn.toLocaleString()} 원</span>
            </div>
              <div className="summary-item">
              <span className="label">총 바이아웃</span>
              <span className="value">{Number(summary.totalBuyout).toLocaleString()} 원</span>
            </div>
              
               <div className="summary-item">
              <span className="label">총 베팅금</span>
              <span className="value">{summary.totalBetAmount.toLocaleString()} 원</span>
            </div>
              
               <div className="summary-item">
              <span className="label">총 레이크 수익</span>
              <span className="value">{summary.totalRake.toLocaleString()} 원</span>
            </div>
          </div>
      <div className="filters between">
      
        <div className ="user-filters">
             <div className="role-tabs">
          {["전체", "부본사", "대리점"].map((role) => (
                <button
                  key={role}
                  className={roleType === (role === "전체" ? "" : role) ? "active" : ""}
                  onClick={() => {
                    setRoleType(role === "전체" ? "" : role);
                    setSelectedUser("");
                  }}
                >
                  {role}
                </button>
              ))}
          </div>
            <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)}>
              <option value="">-- 전체 보기 --</option>
              {userList.map((user) => (
                <option key={user.username} value={user.username}>
                  {user.username}
                </option>
              ))}
            </select>
        </div>
        <div className="date-filters">
        
          <div className="date-buttons">
            <button 
               className={activeFilter === "yesterday" ? "active" : ""}
               onClick={() => setQuickTime("yesterday")}>어제</button>
            <button 
              className={activeFilter === "today" ? "active" : ""}
            onClick={() => setQuickTime("today")}>오늘</button>
            <button 
             className={activeFilter === "thisMonth" ? "active" : ""}
             onClick={() => setQuickTime("thisMonth")}>이번 달</button>
            <button 
               className={activeFilter === "lastMonth" ? "active" : ""}
               onClick={() => setQuickTime("lastMonth")}>지난 달</button>
          </div>
          <div className="date-inputs">
              <input type="datetime-local" value={startDate} onChange={(e) => {setStartDate(e.target.value);setQuickTime("");}} />
              <input type="datetime-local" value={endDate} onChange={(e) => {setEndDate(e.target.value);setQuickTime("");}} />
          </div>

        </div>
      </div>

      {loading ? (
        <p>조회 중...</p>
      ) : (
            <table className="statistics-table">
          <thead>
            <tr>
              <th>지급 시각</th>
              <th>방 번호</th>
              <th>아이디</th>
              <th>소속 대리점</th>
              <th>수익 게임</th>
              <th>게임 베팅 금액</th>
              <th>레이크</th>
              <th>부본사 레이크 지급액</th>
              <th>대리점 레이크 지급액</th>
            </tr>
          </thead>
          <tbody>
            {result.map((stat) => (
              <tr key={stat.username}>
                <td>{stat.betTime.substring(0, 19).replace('T', ' ')}</td>
                <td>{stat.roomNumber}</td> {/* 방 번호 */}
                <td>{stat.user.username}</td> {/* 아이디 */}
                <td>{stat.gameApi.adminUser.username}</td> {/* 소속 대리점 */}
                <td>{stat.gameApi.game.gameName} </td> {/* 수익 */}
                <td>{stat.betAmount.toLocaleString()} 원</td> {/* 게임 베팅 금액 */}
                <td>{stat.rakeAmount.toLocaleString()} 원</td> {/* 레이크 */}
                <td>{stat.rakeAmount_man.toLocaleString()} 원</td> {/* 부본사 레이크 지급액 */}
                <td>{stat.rakeAmount_sub.toLocaleString()} 원</td> {/* 대리점 레이크 */}
              </tr>
            ))}
          </tbody>
        </table>
      )}


           {result.length > 0 ? ( <> 
            <div className="pagination">
                {/* 이전 페이지 버튼 */}
                <button disabled={page === 0} onClick={() => setPage(page - 1)}>
                  ◁
                </button>

                {totalPages > 0 && (
                  <>
                    {/* 현재 페이지 기준 ±2 페이지 범위 계산 */}
                    {Array.from({ length: totalPages }, (_, i) => i)
                      .filter(i => {
                        // 페이지 범위 조정: 항상 5개의 버튼을 보여주기
                        if (page <= 2) return i <= 4; // 첫 페이지일 때, 1~5
                        if (page >= totalPages - 3) return i >= totalPages - 5; // 마지막 페이지일 때, 마지막 5개
                        return i >= page - 2 && i <= page + 2; // 그 외에는 ±2 페이지
                      })
                      .map(i => (
                        <button
                          key={i}
                          className={i === page ? "active" : ""}
                          onClick={() => setPage(i)}
                        >
                          {i + 1}
                        </button>
                      ))}
                  </>
                )}

                {/* 다음 페이지 버튼 */}
                <button disabled={page === totalPages - 1} onClick={() => setPage(page + 1)}>
                  ▷
                </button>
              </div>
        </>): (
            <div className="empty-state">
              <i className="fa-solid fa-exclamation-circle"></i>
              <p className="title">내역이 존재하지 않습니다</p>
            </div>
        )}
      </div>
    </div>
  );
};

export default StatisticsManagement;
